"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeacherEntry = void 0;
const lodash_1 = __importDefault(require("lodash"));
const TeacherEntryUpdateData_1 = require("./TeacherEntryUpdateData");
var TeacherEntry;
(function (TeacherEntry) {
    function createId(assignmentId) {
        return `${assignmentId}`;
    }
    TeacherEntry.createId = createId;
    function create(assignmentId, userId) {
        const now = Date.now();
        return {
            _id: createId(assignmentId),
            createdAt: now,
            modifiedAt: now,
            assignmentId,
            userId,
            entries: {},
        };
    }
    TeacherEntry.create = create;
    /** creates a clone of the given entry and applies the given update logic so we can use it for e.g. comparisons */
    function update(teacherEntry, updates) {
        const cloned = lodash_1.default.cloneDeep(teacherEntry);
        const updateFields = TeacherEntryUpdateData_1.TeacherEntryUpdateData.updateFields(updates);
        lodash_1.default.forEach(updateFields, (value, field) => lodash_1.default.set(cloned, field, value));
        return cloned;
    }
    TeacherEntry.update = update;
    function entryForPin(entry, pinId) {
        return pinId ? lodash_1.default.get(entry && entry.entries, pinId) : undefined;
    }
    TeacherEntry.entryForPin = entryForPin;
})(TeacherEntry || (exports.TeacherEntry = TeacherEntry = {}));
//# sourceMappingURL=TeacherEntry.js.map